import React, { useEffect, useState, useId } from "react"
import SVGCache from "./svg-cache"

// Rewrites every internal id (and its url(#id)/href="#id" references) with a
// per-instance prefix. Without this, inlining the same SVG more than once puts
// duplicate ids in the DOM and clip-path/gradient/mask references resolve to
// the first match, breaking clipping (shapes render unclipped).
const namespaceIds = (svg, prefix) => {
  const ids = new Set()
  const idRe = /\bid="([^"]+)"/g
  let m
  while ((m = idRe.exec(svg))) ids.add(m[1])
  if (!ids.size) return svg

  let out = svg
  for (const id of ids) {
    const esc = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    const safe = `${prefix}-${id}`
    out = out
      .replace(new RegExp(`id="${esc}"`, "g"), `id="${safe}"`)
      .replace(new RegExp(`url\\(#${esc}\\)`, "g"), `url(#${safe})`)
      .replace(new RegExp(`((?:xlink:)?href)="#${esc}"`, "g"), `$1="#${safe}"`)
  }
  return out
}

const DynamicSVG = ({ url, recolor = true, className, cache = true }) => {
  if (!url || !url.includes(".svg")) return null
  const [svgContent, setSvgContent] = useState(null)
  const prefix = `dsvg${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`

  useEffect(() => {
    const loadSVG = async () => {
      const cachedSVG = await SVGCache.getSVG(url, recolor, cache)
      if (cachedSVG) {
        setSvgContent(namespaceIds(cachedSVG, prefix))
      }
    }

    loadSVG()
  }, [url, recolor, cache, prefix])

  // Only render when SVG content is loaded to avoid hydration mismatches
  if (!svgContent) {
    return <div className={className} />
  }

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  )
}

export default DynamicSVG
